export default __webpack_public_path__ + "/dist/images/pending-active.e7a39dc56ebf819c5e8d064d92a5082c.svg";